










































































import { Component, Prop, Vue } from "vue-property-decorator";
import { DefaultFilters } from "@/data/filters/client";
import { DefaultSorters } from "@/data/sorters/client";
import { ISorter, IFilter } from "@/models/tables";
import ClientsProvider from "@/components/app/admin/clients/clientsProvider.vue";
import { ISegmentTypes } from "@/data/enums/segments";
import { DataModules } from "@/store/modules/data";
import { UserMetaKeys } from "@/data/enums/users";
import { ListDisplayMode } from "@/data/constants";

@Component({
  components: {
    ClientsProvider,
    "add-segment-message": () =>
      import("@/components/app/admin/segments/addSegmentMessage.vue"),
    "clients-table-view": () =>
      import("@/components/app/admin/clients/clientsTableView.vue"),
    "clients-grid": () =>
      import("@/components/app/admin/clients/clientsGrid.vue")
  }
})
export default class ClientsListing extends Vue {
  @Prop({ default: () => DefaultFilters })
  public availableFilters!: (vm: ClientsListing) => IFilter[];

  @Prop({ default: () => DefaultSorters })
  public availableSorters!: (vm: ClientsListing) => ISorter[];

  @Prop({ default: () => () => ({}) })
  public manualFilters!: (
    vm?: ClientsListing
  ) => Record<string, string | number | boolean>;

  // Data

  public displayMode = ListDisplayMode.GRID;
  public displayModeStoragePath = UserMetaKeys.UI_CLIENTS_DISPLAY_MODE;
  public segmentType = ISegmentTypes.CLIENT;

  // Computed

  public get isDisplayModeTable() {
    return this.displayMode === ListDisplayMode.TABLE;
  }

  public get isDisplayModeGrid() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get segmentApiProps() {
    return {
      with: this.$store.getters[`data/${DataModules.CLIENTS}/withParam`]
    };
  }

  public get clientsFilters() {
    return this.availableFilters(this);
  }

  public get clientsSorters() {
    return this.availableSorters(this);
  }

  public get providerManualFilters() {
    return this.manualFilters();
  }
}
